module.exports = __webpack_public_path__ + "94d3e508e3d5c9f951e32cf7f22196c7.pdf";